"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.duration = void 0;
const unthrottledTimer_1 = require("./unthrottledTimer");
// no typings so this needs a standard require
// eslint-disable-next-line @typescript-eslint/no-var-requires
const present = require("present");
/**
 * Start a timer, and allow for the creation of a promise at-will to wait until that timer has ended.
 *
 * Uses an unthrottled (worker-backed) timer so battles keep progressing when the
 * browser tab is inactive.
 *
 * @param ms the number of milliseconds to wait
 */
const duration = (ms) => {
    const startTime = present();
    return {
        remaining: () => {
            const endTime = present();
            const timePassed = endTime - startTime;
            const remaining = Math.max(ms - timePassed, 0);
            const promise = new Promise((resolve) => {
                if (remaining === 0) {
                    resolve();
                    return;
                }
                (0, unthrottledTimer_1.setTimeoutUnthrottled)(() => resolve(), remaining);
            });
            return {
                promise,
                ms: remaining,
            };
        },
    };
};
exports.duration = duration;
